import { Box, IconButton, Typography } from '@mui/material';
import { t } from 'react-i18nify';
import React, { FC, MouseEventHandler, useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import { TranslationWithList, TSlotInfo } from '../Interface/Interface';
import { darkBlue, optionErrorBoxBg } from '../Constants/Colors';
export interface IOptionInfoProps {
  slotInfo?: TSlotInfo;
  show: boolean;
  onClose: MouseEventHandler;
}

export const OptionInfo: FC<IOptionInfoProps> = ({
  slotInfo,
  show,
  onClose
}) => {
  const [slotInfoHint, setSlotInfoHint] = useState<
    TranslationWithList | undefined
  >(undefined);
  useEffect(() => {
    if (slotInfo instanceof Array) {
      setSlotInfoHint({
        translationKey: 'optionSelectionErrors.slotTypeIsUsed',
        listItems: slotInfo.map(({ slotTypeTitle }) => slotTypeTitle)
      });
      return;
    }
    const translationKey =
      (slotInfo?.slotsNeeded !== undefined &&
        'optionSelectionErrors.slotTypeIsFull') ||
      (slotInfo?.slotsProvided !== undefined &&
        'optionSelectionErrors.slotTypeIsUsed');
    if (!translationKey) {
      setSlotInfoHint(undefined);
      return;
    }
    setSlotInfoHint({
      translationKey,
      listItems: slotInfo?.slots?.map(({ title }) => title)
    });
  }, [slotInfo]);
  if (!slotInfo || !slotInfoHint || !show) {
    return null;
  }
  return (
    <Box
      className="optionInfo"
      sx={{
        bgcolor: optionErrorBoxBg,
        color: darkBlue,
        display: 'flex',
        flexDirection: 'column',
        pointerEvents: 'none',
        flexBasis: '100%',
        mt: 2
      }}>
      <IconButton
        sx={{
          alignSelf: 'end',
          pointerEvents: 'all'
        }}
        size="small"
        onClick={(evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          onClose(evt);
        }}>
        <CloseIcon sx={{ fontSize: '0.9rem', color: darkBlue }} />
      </IconButton>
      <Box sx={{ display: 'flex', mt: -1, pt: 0, pr: 1.5, pl: 1.5, pb: 1 }}>
        <InfoIcon sx={{ mt: -0.5, mr: 1 }} />
        <Box
          sx={{
            '& .MuiTypography-root': { color: darkBlue, fontSize: '0.85rem' }
          }}>
          <Typography variant="h4">{t(slotInfoHint.translationKey)}</Typography>
          {slotInfoHint.listItems?.map((title, idx) => (
            <Typography variant="body2" key={idx}>
              {title}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
